import { z } from 'zod'
import { crmProviderConnectionSummarySchema } from './crm-work-read'

export const CRM_PROVIDER_CONNECTION_WRITE_CONTRACT_VERSION = '1.0.0' as const

const providerConnectionSideEffectsSchema = z.object({
  db1Read: z.boolean().optional(),
  db1Written: z.boolean().optional(),
  auditWritten: z.boolean().optional(),
}).passthrough()

export const crmProviderConnectionResponseSchema = z.object({
  contract_version: z.literal(CRM_PROVIDER_CONNECTION_WRITE_CONTRACT_VERSION),
  connection: crmProviderConnectionSummarySchema,
  created: z.boolean().optional(),
  sideEffects: providerConnectionSideEffectsSchema,
}).passthrough()

export const crmProviderConnectionCreateRequestSchema = z.record(z.unknown())
export const crmProviderConnectionStatusRequestSchema = z.record(z.unknown())
export const crmProviderConnectionCredentialRefRequestSchema = z.record(z.unknown())

export type CrmProviderConnectionResponse = z.infer<typeof crmProviderConnectionResponseSchema>
export type CrmProviderConnectionCreateRequest = z.infer<typeof crmProviderConnectionCreateRequestSchema>
export type CrmProviderConnectionStatusRequest = z.infer<typeof crmProviderConnectionStatusRequestSchema>
export type CrmProviderConnectionCredentialRefRequest = z.infer<typeof crmProviderConnectionCredentialRefRequestSchema>
